import * as React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CommonTabsItem } from "@/components/app/tabs/types";
import { useNavigate } from "react-router";

interface Props {
  tabs: CommonTabsItem[];
  children?: React.ReactNode;
}

export const CommonTabs: React.FC<Props> = ({ tabs, children }) => {
  const navigate = useNavigate();

  const handleClick = (link: string) => {
    navigate(link);
  };

  return (
    <TabsList className="flex h-14 justify-start bg-transparent px-2 py-0">
      {tabs.map(tab => (
        <TabsTrigger
          key={tab.name}
          value={tab.name}
          onClick={() => (tab.link ? handleClick(tab.link) : undefined)}
          className="radius-0 group flex h-full items-center rounded-none border-b-2 border-transparent px-4 py-0 text-sm font-medium text-gray-500 shadow-none hover:border-desert-sand-300 hover:text-gray-700 data-[state=active]:border-desert-sand-700 data-[state=active]:bg-transparent data-[state=active]:text-desert-sand-700"
        >
          {tab.icon}
          <span className="px-1">{tab.label}</span>
        </TabsTrigger>
      ))}
      {children}
    </TabsList>
  );
};
